import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { useLanguage } from "@/contexts/LanguageContext";
import Header from "@/components/Header";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Calendar } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MONTHS_DE = ["","Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
const MONTHS_EN = ["","January","February","March","April","May","June","July","August","September","October","November","December"];

export default function NewsletterPage() {
  const { id } = useParams();
  const { language } = useLanguage();
  const [newsletter, setNewsletter] = useState(null);
  const months = language === "de" ? MONTHS_DE : MONTHS_EN;

  useEffect(() => {
    axios.get(`${API}/public/newsletters/${id}`).then(r => setNewsletter(r.data)).catch(() => {});
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!newsletter) return (
    <div className="min-h-screen bg-sand-50">
      <Header />
      <div className="flex justify-center py-24"><div className="h-8 w-8 border-2 border-forest-800 border-t-transparent rounded-full animate-spin" /></div>
    </div>
  );

  const content = language === "de" ? newsletter.content_de : newsletter.content_en;
  const title = language === "de" ? newsletter.title_de : newsletter.title_en;

  return (
    <div className="min-h-screen bg-sand-50">
      <Header />
      <main className="px-6 md:px-12 py-12 max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-stone-500 hover:text-forest-800 mb-8 text-sm">
          <ArrowLeft className="h-4 w-4" />{language === "de" ? "Zurück" : "Back"}
        </Link>

        <div className="mb-8">
          <div className="flex items-center gap-2 text-sm text-stone-500 mb-3">
            <Calendar className="h-4 w-4" />
            <span>{months[newsletter.month]} {newsletter.year}</span>
          </div>
          <h1 className="font-outfit text-3xl sm:text-4xl font-medium text-forest-900 leading-tight">
            {title}
          </h1>
        </div>

        {newsletter.image_url && (
          <img src={newsletter.image_url} alt="" className="w-full h-64 object-cover rounded-2xl mb-8" />
        )}

        <Card className="bg-white rounded-2xl border-stone-200 shadow-sm">
          <CardContent className="p-8 md:p-10">
            <div className="prose prose-stone max-w-none text-stone-700 leading-relaxed whitespace-pre-wrap">
              {content}
            </div>
          </CardContent>
        </Card>
      </main>

      <footer className="py-6 px-6 md:px-12 border-t border-stone-200 mt-12">
        <div className="max-w-7xl mx-auto flex items-center justify-center">
          <p className="text-stone-500 text-xs">© 2026 Universität Trier. Learning Brain Lab</p>
        </div>
      </footer>
    </div>
  );
}
